import { Props as DropdownItemProps } from './SideMenuDropdownItem';

export const dropSideLines = (links: Array<DropdownItemProps>): Array<DropdownItemProps> =>
  links.filter((item, i) => !(item.isLine && [0, links.length - 1].includes(i)));
